/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CustomQuestionnaireQuestionRule } from './CustomQuestionnaireQuestionRule';
import {
  CustomQuestionnaireQuestionRuleFromJSON,
  CustomQuestionnaireQuestionRuleFromJSONTyped,
  CustomQuestionnaireQuestionRuleToJSON,
} from './CustomQuestionnaireQuestionRule';
import type { CustomQuestionnaireAnswerOption } from './CustomQuestionnaireAnswerOption';
import {
  CustomQuestionnaireAnswerOptionFromJSON,
  CustomQuestionnaireAnswerOptionFromJSONTyped,
  CustomQuestionnaireAnswerOptionToJSON,
} from './CustomQuestionnaireAnswerOption';
import type { QuestionTypeEnum } from './QuestionTypeEnum';
import { QuestionTypeEnumFromJSON, QuestionTypeEnumFromJSONTyped, QuestionTypeEnumToJSON } from './QuestionTypeEnum';

/**
 * Adds nested create feature
 * @export
 * @interface CustomQuestionnaireQuestion
 */
export interface CustomQuestionnaireQuestion {
  /**
   *
   * @type {number}
   * @memberof CustomQuestionnaireQuestion
   */
  readonly id: number;
  /**
   *
   * @type {number}
   * @memberof CustomQuestionnaireQuestion
   */
  order?: number;
  /**
   *
   * @type {string}
   * @memberof CustomQuestionnaireQuestion
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof CustomQuestionnaireQuestion
   */
  text: string;
  /**
   *
   * @type {string}
   * @memberof CustomQuestionnaireQuestion
   */
  description?: string | null;
  /**
   *
   * @type {QuestionTypeEnum}
   * @memberof CustomQuestionnaireQuestion
   */
  questionType: QuestionTypeEnum;
  /**
   *
   * @type {boolean}
   * @memberof CustomQuestionnaireQuestion
   */
  freeTextRequired?: boolean;
  /**
   *
   * @type {string}
   * @memberof CustomQuestionnaireQuestion
   */
  freeTextDefaultValue?: string | null;
  /**
   *
   * @type {Array<CustomQuestionnaireAnswerOption>}
   * @memberof CustomQuestionnaireQuestion
   */
  options?: Array<CustomQuestionnaireAnswerOption>;
  /**
   *
   * @type {Array<CustomQuestionnaireQuestionRule>}
   * @memberof CustomQuestionnaireQuestion
   */
  rules?: Array<CustomQuestionnaireQuestionRule>;
}

/**
 * Check if a given object implements the CustomQuestionnaireQuestion interface.
 */
export function instanceOfCustomQuestionnaireQuestion(value: object): value is CustomQuestionnaireQuestion {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('text' in value) || value['text'] === undefined) return false;
  if (!('questionType' in value) || value['questionType'] === undefined) return false;
  return true;
}

export function CustomQuestionnaireQuestionFromJSON(json: any): CustomQuestionnaireQuestion {
  return CustomQuestionnaireQuestionFromJSONTyped(json, false);
}

export function CustomQuestionnaireQuestionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CustomQuestionnaireQuestion {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    order: json['order'] == null ? undefined : json['order'],
    name: json['name'],
    text: json['text'],
    description: json['description'] == null ? undefined : json['description'],
    questionType: QuestionTypeEnumFromJSON(json['question_type']),
    freeTextRequired: json['free_text_required'] == null ? undefined : json['free_text_required'],
    freeTextDefaultValue: json['free_text_default_value'] == null ? undefined : json['free_text_default_value'],
    options:
      json['options'] == null
        ? undefined
        : (json['options'] as Array<any>).map(CustomQuestionnaireAnswerOptionFromJSON),
    rules:
      json['rules'] == null ? undefined : (json['rules'] as Array<any>).map(CustomQuestionnaireQuestionRuleFromJSON),
  };
}

export function CustomQuestionnaireQuestionToJSON(value?: Omit<CustomQuestionnaireQuestion, 'id'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    order: value['order'],
    name: value['name'],
    text: value['text'],
    description: value['description'],
    question_type: QuestionTypeEnumToJSON(value['questionType']),
    free_text_required: value['freeTextRequired'],
    free_text_default_value: value['freeTextDefaultValue'],
    options:
      value['options'] == null
        ? undefined
        : (value['options'] as Array<any>).map(CustomQuestionnaireAnswerOptionToJSON),
    rules:
      value['rules'] == null ? undefined : (value['rules'] as Array<any>).map(CustomQuestionnaireQuestionRuleToJSON),
  };
}
